import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventNotification extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventNotification';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            title: null,
            content: null,
            scheduledAt: null,
            sentAt: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.items) {
    //         data.items = new models.api.EventNotification(data.EventNotification)
    //     }
    //     return data
    // }
}

const servicePath = 'notification';
const servicePlugin = makeServicePlugin({
    Model: EventNotification,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin